module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail-container"
  }, [(_vm.payEnterpriseList.length > 0) ? _c('div', {
    staticClass: "mod2 flex-col"
  }, [_c('div', {
    staticClass: "bd1 flex-col"
  }, [_c('div', {
    staticClass: "bd2 flex-row"
  }, [_c('span', {
    staticClass: "info2"
  }, [_vm._v("开票抬头")]), _vm._v(" "), _c('div', {
    staticClass: "group1 flex-col"
  }, [_c('router-link', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "to": {
        name: 'invoiceTitleModify',
        params: {
          order: _vm.order,
          addressType: 4
        }
      }
    }
  }, [_c('span', {
    staticClass: "word4"
  }, [_vm._v("修改")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line",
    staticStyle: {
      "margin-top": "21px",
      "margin-left": "15px"
    }
  }), _vm._v(" "), _vm._l((_vm.payEnterpriseList), function(payEnterprise, index) {
    return _c('div', {
      staticStyle: {
        "height": "60px",
        "margin-left": "15px"
      }
    }, [_c('div', {
      staticClass: "bd6 flex-col"
    }, [_c('span', {
      staticClass: "word3"
    }, [_vm._v(_vm._s(payEnterprise.enterpriseInvoiceTitle))])]), _vm._v(" "), (index < _vm.payEnterpriseList.length - 1) ? _c('div', {
      staticClass: "bd5 flex-col"
    }, [_c('div', {
      staticClass: "full-split-line"
    })]) : _vm._e()])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mod3 flex-col"
  }, [_c('div', {
    staticClass: "layer2 flex-col"
  }, [_c('div', {
    staticClass: "box2 flex-row"
  }, [_c('span', {
    staticClass: "word5"
  }, [_vm._v("发票寄送地址")]), _vm._v(" "), _c('div', {
    staticClass: "layer3 flex-col"
  }, [_c('router-link', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "to": {
        name: 'WeappAddress',
        params: {
          order: _vm.order,
          addressType: 4
        }
      }
    }
  }, [_c('span', {
    staticClass: "info5"
  }, [_vm._v("修改")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line",
    staticStyle: {
      "margin-top": "21px",
      "margin-left": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-didian research-font-color",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v(_vm._s(_vm.order.invoiceAddress || '无发票寄送地址'))]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.order.invoiceName) + " " + _vm._s(_vm.order.invoiceMobile))])])])])])]), _vm._v(" "), (_vm.canAddPayEnterprise) ? _c('span', {
    staticClass: "txt2"
  }, [_vm._v("\n          下单成功后，吉凯工作人员会主动联系您为您开具发票。发票未寄出之前，您可以修改发票抬头与寄送地址\n        ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8299c0b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/MyInvoice/updateInvoiceTitle.vue
// module id = 1685
// module chunks = 8